import { useMemo } from "react";
import { useRecoilValue } from "recoil";
import { projectIdState } from "atoms/atoms-admin";
import { variantIdState } from "atoms/atoms-component";
import { BrmDetailTable } from "brm/tables/BrmTables";
import { LoadingSpinner, ErrorBanner } from "components/elements";

import {
  createColumnBooleanNoEditMapped,
  createColumnMappedNoEdit,
  createColumnNameDetails,
} from "brm/tables/services/column/columnFactory";
// Styles
import * as S from "brm/styles/details-table.styles";
import { RoutePath } from "routes/route-paths";
import { SystemApi } from "features/brm";

interface IOutDataProps {
  elementNameInUrl: string;
  selectedElement: {
    id: string;
  };
  tableTitle: string;
}

const OutDataTable = ({ elementNameInUrl, selectedElement, tableTitle }: IOutDataProps) => {
  const columns = useMemo(
    () => [
      createColumnNameDetails(RoutePath.Datatype.replace(":id", "")),
      createColumnMappedNoEdit("category"),
      createColumnBooleanNoEditMapped("isInternal"),
      createColumnBooleanNoEditMapped("isInput"),
      createColumnBooleanNoEditMapped("isOutput"),
      createColumnBooleanNoEditMapped("isStored"),
      createColumnBooleanNoEditMapped("isProcessed"),
    ],
    []
  );

  const projectId = useRecoilValue(projectIdState);
  const variantId = useRecoilValue(variantIdState);

  const { data: outData, isError: isOutDataError } = SystemApi.useElementOutData({
    elementId: selectedElement.id,
    elementName: elementNameInUrl,
    projectId,
    variantId,
    options: { enabled: !!selectedElement?.id && !!elementNameInUrl },
  });

  if (isOutDataError) {
    return <ErrorBanner msg="Error while loading OutData" />;
  }

  if (outData) {
    return (
      <S.DetailsContainer id="OutDataTable_detailsPanel">
        <BrmDetailTable
          data={outData}
          columns={columns}
          customProps={{ id: "OutDataTable_detailsTable" }}
          showRowSelect={false}
          tableTitle={tableTitle}
        />
      </S.DetailsContainer>
    );
  }

  return <LoadingSpinner />;
};

export default OutDataTable;
